var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrowIcon8X14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35399 0.645917C7.40056 0.692363 7.4375 0.747539 7.46271 0.808284C7.48791 0.869029 7.50089 0.93415 7.50089 0.999917C7.50089 1.06568 7.48791 1.13081 7.46271 1.19155C7.4375 1.2523 7.40056 1.30747 7.35399 1.35392L1.70699 6.99992L7.35399 12.6459C7.44788 12.7398 7.50062 12.8671 7.50062 12.9999C7.50062 13.1327 7.44788 13.26 7.35399 13.3539C7.26011 13.4478 7.13277 13.5005 6.99999 13.5005C6.86722 13.5005 6.73988 13.4478 6.64599 13.3539L0.645993 7.35392C0.59943 7.30747 0.562487 7.2523 0.537281 7.19155C0.512074 7.13081 0.4991 7.06568 0.4991 6.99992C0.4991 6.93415 0.512074 6.86903 0.537281 6.80828C0.562487 6.74754 0.59943 6.69236 0.645993 6.64592L6.64599 0.645917C6.69244 0.599354 6.74761 0.562411 6.80836 0.537205C6.86911 0.511998 6.93423 0.499023 6.99999 0.499023C7.06576 0.499023 7.13088 0.511998 7.19163 0.537205C7.25237 0.562411 7.30755 0.599354 7.35399 0.645917Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon8X14);
export default __webpack_public_path__ + "static/media/left_arrow_icon-8x14.64d4738d010cda706c351fc184ce0357.svg";
export { ForwardRef as ReactComponent };